export default __webpack_public_path__ + "static/media/731.d76dd08f.png";